module.exports = __webpack_public_path__ + "media/bootstrap-icons/brightness-alt-high-fill-2c39e238.svg";